import React from "react"
import { Link, withRouter } from "react-router-dom"
import iconProfile from '../../assets/icons/profile.svg'
import iconChangePassword from '../../assets/icons/password.svg'

const SettingsMenu = () => {
    return (
        <div className="menu">
            <Link className="item" to="/settings/profile"><img src={iconProfile} alt=""/><span>Profile</span></Link>
            <Link className="item" to="/settings/change-password"><img src={iconChangePassword} alt=""/><span>Change Password</span></Link>
        </div>
    )
}

export default withRouter(SettingsMenu)